<template>
  <div :id="`create_category_${modalNumber}`"  class="modal fade rtl" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="font-weight-bold">دسته بندی جدید</p>
        </div>
        <div class="modal-body">
          <form :id="`create_category_form_${modalNumber}`" @submit.prevent="createCategory">
            <div class="form-group">
              <label for="title">{{ $t('label.title') }}</label>
              <input type="text" class="form-control" name="title" v-model="title" >
            </div>
            <div class="form-group">
              <label for="url">{{ $t('label.url') }}</label>
              <input type="text" class="form-control" name="url" v-model="url" >
            </div>
            <div class="form-group">
              <button :id="`create_category_btn_${modalNumber}`" type="submit" class="btn btn-primary">
                {{ $t('btn.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {ticketService} from "@/common/api.service";
import toastr from "toastr";

export default {
  name: "create-category-modal",
  props: {
    parent_id: {
      required: false,
      default: 1
    },
    modalNumber: {
      required: false,
      default: 'main_cat'
    }
  },
  data() {
    return {
      title: null,
      url: null,
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  methods: {
    createCategory() {
      let form = $('#create_category_form_' + this.modalNumber)
      let btn = $('#create_category_btn_' + this.modalNumber)

      form.validate({
        ignore: ":hidden",
        rules: {
          title: {
            required: true
          },
          url: {
            required: true
          },
        }
      })

      if(!form.valid()) {
        return;
      }

      KTApp.progress(btn)

      let data = {
        title: this.title,
        url: this.url,
        parent_id: this.parent_id,
        modalNumber: this.modalNumber
      }

      ticketService.createCategory(data)
          .then(async response => {
            this.url = null
            this.title = null
            await this.$store.dispatch('ticket/fetchTicketCategories')
            $('#create_category_' + data.modalNumber).modal('hide')
            this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            if (response.data) {
              form.validate().showErrors(response.data.data)
            }
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    }
  }
}
</script>

<style scoped>

</style>